module.exports = __webpack_public_path__ + "img/con4.23d1805b.png";